import React from 'react';
import { CheckPicker, Drawer } from 'rsuite';

export default function MobileFilterDrawer({
  selectFieldData,
  handleChange,
  attributesName,
  selectedFieldValue,
  open,
  close
}) {
  return (
    <>
      <Drawer size="xs" open={open} onClose={close}>
        <Drawer.Header>
          <Drawer.Title>More Features</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <CheckPicker
            data={selectFieldData.Category}
            style={{ width: '100%', marginTop: 10, marginBottom: 10 }}
            placeholder={`Select ${attributesName?.Category}` || 'Select Category'}
            value={selectedFieldValue.Category}
            onChange={value => {
              handleChange('Category', value);
            }}
          />
          <CheckPicker
            data={selectFieldData.Product_Name}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.ProductName}` || 'Select Product Name'}
            value={selectedFieldValue.Product_Name}
            onChange={value => handleChange('Product_Name', value)}
          />
          <CheckPicker
            data={selectFieldData.Type}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.ProductType}` || 'Select Item Type'}
            value={selectedFieldValue.Type}
            onChange={value => {
              handleChange('Type', value);
            }}
          />
          <CheckPicker
            data={selectFieldData.Color}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.color}` || 'Select Color'}
            value={selectedFieldValue.Color}
            onChange={value => {
              handleChange('Color', value);
            }}
          />
          <CheckPicker
            data={selectFieldData.Buyer_Style}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.BuyerSku}` || 'Select Buyer Style'}
            value={selectedFieldValue.Buyer_Style}
            onChange={value => handleChange('Buyer_Style', value)}
          />
          <CheckPicker
            data={selectFieldData.Finish}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.finish}` || 'Select Finish'}
            value={selectedFieldValue.Finish}
            onChange={value => handleChange('Finish', value)}
          />
          <CheckPicker
            data={selectFieldData.Alias_Code}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.AliasCode}` || 'Select Alias Code'}
            value={selectedFieldValue.Alias_Code}
            onChange={value => handleChange('Alias_Code', value)}
          />
          <CheckPicker
            data={selectFieldData.Search_keyword}
            style={{ width: '100%', marginBottom: 10 }}
            placeholder={`Select ${attributesName?.searchKeyword}` || 'Select Search Keyword'}
            value={selectedFieldValue.Search_keyword}
            onChange={value => handleChange('Search_keyword', value)}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
}
